// extracted by mini-css-extract-plugin
export default {"root":"ConfigForm_root__bMYaF"};